import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { SearchOverlay } from "./SearchOverlay";
export function Layout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const {
    pathname,
    search,
    hash
  } = useLocation();
  const outlet = useOutlet();
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({
        behavior: "smooth"
      }), 250);
      return () => window.clearTimeout(t);
    }
    window.scrollTo({
      top: 0
    });
  }, [pathname, search, hash]);
  const closeSearch = useCallback(() => setSearchOpen(false), []);
  return <div className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-235" data-mp="3fp1zme89ou14">
      <AnnouncementBar data-id="element-236" data-mp="3fmpjm6m2ktqp" />
      <Header onSearch={() => setSearchOpen(true)} data-id="element-237" data-mp="1isou0iv77z8e" />
      <AnimatePresence mode="wait" initial={false} data-id="element-238" data-mp="1irwyt95ik3in">
        <motion.main key={pathname} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: "easeOut"
      }} data-id="element-239" data-mp="1mt8tht38vexp">
          {outlet}
        </motion.main>
      </AnimatePresence>
      <Footer data-id="element-240" data-mp="1wi8rb960g4ab" />
      <CartDrawer data-id="element-241" data-mp="1wj1ygb8vsvsz" />
      <SearchOverlay open={searchOpen} onClose={closeSearch} data-id="element-242" data-mp="1wlob2pamq1i2" />
    </div>;
}